import { LOGIN_PAGE_BANNER } from '../Configurations/env'
export const SSO_ERROR_ASSET = [
  {
    src: new URL('~/public/assets/images/SsoError.svg', import.meta.url).href,
    alt: 'Home Image',
    as: 'image/svg+xml'
  }
]

export const CROSS_WHITE_ASSET = [
  {
    src: new URL('~/public/assets/images/crossWhite.svg', import.meta.url).href,
    alt: 'Home Image',
    as: 'image/svg+xml'
  }
]

export const PASSWORD_EXPIRY = [
  {
    src: new URL('~/public/assets/images/PasswordExpiry.png', import.meta.url)
      .href,
    alt: 'Password Expired',
    as: 'image/png'
  }
]

export const WHITE_BACK_ARROW_ASSET = [
  {
    src: new URL('~/public/assets/images/WhiteBackArrow.svg', import.meta.url)
      .href,
    alt: 'Home Image',
    as: 'image/svg+xml'
  }
]

export const POPUP_ASSET = [
  {
    src: new URL('~/public/assets/images/PopupInfo.svg', import.meta.url).href,
    alt: 'Home Image',
    as: 'image/svg+xml'
  }
]

export const SOMETHING_WENT_WRONG_ASSET = [
  {
    src: new URL(
      '~/public/assets/images/somethingWentWrong.svg',
      import.meta.url
    ).href,
    alt: 'Home Image',
    as: 'image/svg+xml'
  }
]

export const PLAY_STORE_ASSET = [
  {
    src: new URL('~/public/assets/images/PlayStore.svg', import.meta.url).href,
    alt: 'Home Image',
    as: 'image/svg+xml'
  }
]

export const ONBOARDING_ASSET = [
  {
    src: new URL('~/public/assets/images/Onboarding.svg', import.meta.url).href,
    alt: 'Home Image',
    as: 'image/svg+xml'
  }
]

export const MONEY_GROW_ASSET = [
  {
    src: new URL('~/public/assets/images/Container.svg', import.meta.url).href,
    alt: 'Home Image',
    as: 'image/svg+xml'
  }
]

export const CONFIRM_SUCCESS_ASSET = [
  {
    src: new URL('~/public/assets/images/ConfirmSuccess.svg', import.meta.url)
      .href,
    alt: 'Home Image',
    as: 'image/svg+xml'
  }
]

export const CHECK_VALIDATE_ASSET = [
  {
    src: new URL('~/public/assets/images/checkValidate.svg', import.meta.url)
      .href,
    alt: 'Home Image',
    as: 'image/svg+xml'
  }
]

export const CHECK_ASSET = [
  {
    src: new URL('~/public/assets/images/check.svg', import.meta.url).href,
    alt: 'Home Image',
    as: 'image/svg+xml'
  }
]

export const APPLE_STORE_ASSET = [
  {
    src: new URL('~/public/assets/images/AppleStore.svg', import.meta.url).href,
    alt: 'Home Image',
    as: 'image/svg+xml'
  }
]

export const BACK_ARROW_ASSET = [
  {
    src: new URL('~/public/assets/images/BackArrow.svg', import.meta.url).href,
    alt: 'Home Image',
    as: 'image/svg+xml'
  }
]

export const BULB_ASSET = [
  {
    src: new URL('~/public/assets/images/Bulb.svg', import.meta.url).href,
    alt: 'Home Image',
    as: 'image/svg+xml'
  }
]

export const LIGHT_MONEY_GROW_ASSET = [
  {
    src: new URL(LOGIN_PAGE_BANNER, import.meta.url).href,
    alt: 'Home Image',
    as: 'image/avif'
  },
  {
    src: new URL(
      '~/public/assets/images/Illustrationlight.png?as=webp',
      import.meta.url
    ).href,
    alt: 'Home Image',
    as: 'image/webp'
  },
  {
    src: new URL(
      '~/public/assets/images/Illustrationlight.png',
      import.meta.url
    ).href,
    alt: 'Home Image',
    as: 'image/png'
  }
]

export const HEADER_MOBILE_ASSET = [
  {
    src: new URL('~/public/assets/images/HeaderMb.svg', import.meta.url).href,
    alt: 'Home Image',
    as: 'image/svg+xml'
  }
]

export const HEADER_ASSET = [
  {
    src: new URL('~/public/assets/images/Header.svg', import.meta.url).href,
    alt: 'Home Image',
    as: 'image/svg+xml'
  }
]

export const REDIRECT_ASSET = [
  {
    src: new URL('~/public/assets/images/Redirect.svg', import.meta.url).href,
    alt: 'Redirect Image',
    as: 'image/svg+xml'
  }
]

export const Disabled_QR = [
  {
    src: new URL('~/public/assets/images/DisabledQr.svg', import.meta.url).href,
    alt: 'Redirect Image',
    as: 'image/svg+xml'
  }
]

export const QRLOGO = [
  {
    src: new URL('~/public/assets/images/QrLogo.svg', import.meta.url).href,
    alt: 'Redirect Image',
    as: 'image/svg+xml'
  }
]

export const NRI = [
  {
    src: new URL('~/public/assets/images/NRI.svg', import.meta.url).href,
    alt: 'NRI',
    as: 'image/svg'
  }
]

export const NRI_MOBILE_IMAGE = [
  {
    src: new URL('~/public/assets/images/NriMobileImage.svg', import.meta.url)
      .href,
    alt: 'NRI_MOBILE_IMAGE',
    as: 'image/png'
  }
]

export const AXIS_LOGO_BLACK = [
  {
    src: new URL('~/public/assets/images/AxisLogoBlack.svg', import.meta.url)
      .href,
    alt: 'AXIS_LOGO_BLACK',
    as: 'image/png'
  }
]

export const CUSTOMERSUPPORT = [
  {
    src: new URL('~/public/assets/images/customerSupport.svg', import.meta.url)
      .href,
    alt: 'Home Image',
    as: 'image/svg+xml'
  }
]

export const ALREADY_ACTIVATED_ACCOUNT = [
  {
    src: new URL('~/public/assets/images/AlreadyActivated.svg', import.meta.url)
      .href,
    alt: 'Already Activated Account Image',
    as: 'image/svg+xml'
  }
]

export const COULD_NOT_FIND_ACCOUNT = [
  {
    src: new URL('~/public/assets/images/invest.svg', import.meta.url).href,
    alt: 'Invest from Axis Direct',
    as: 'image/svg+xml'
  }
]

export const CONSENT_MODAL = [
  {
    src: new URL('~/public/assets/images/ConsentModal.svg', import.meta.url)
      .href,
    alt: 'Invest from Axis Direct',
    as: 'image/svg+xml'
  }
]

export const NOT_ELIGIBLE_DIALOG_BANNER = [
  {
    src: new URL('~/public/assets/images/not-eligible.png', import.meta.url)
      .href,
    alt: 'Not Eligible',
    as: 'image/png'
  }
]
